import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'esn-wegestu';
  private observer!: MutationObserver;


  constructor(private router: Router) {}

  ngOnInit() {
    // Observe route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const url = event.urlAfterRedirects;
        const shouldHideRecaptcha = !url.startsWith('/auth');
        this.toggleBadgeVisibility(shouldHideRecaptcha);
      });
  }

  ngAfterViewInit() {   
    setTimeout(() => {
      const fallback = document.querySelector('iframe[src*="fallback"]');      
      if (fallback) {
        fallback.remove();
      }
    }, 5000);
    this.initRecaptchaBadgeObserver();
  }

  private toggleBadgeVisibility(hide: boolean) {
    const badge = document.querySelector('.grecaptcha-badge') as HTMLElement;
    if (badge) {
      badge.style.display = hide ? 'none' : 'block';
    }
  }

  private initRecaptchaBadgeObserver() {
  this.observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const badge = document.querySelector('.grecaptcha-badge') as HTMLElement;
      if (badge) {
        const shouldHide = !this.router.url.startsWith('/auth');
        badge.style.display = shouldHide ? 'none' : 'block';
      }

      // Supprimer les iframes de fallback s'il y en a
      const fallbacks = document.querySelectorAll('iframe[src*="fallback"]');
      fallbacks.forEach(el => el.remove());
    }
  });

  this.observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
}
